import React from 'react'

function AboutIconContainer(props) {
  return (
    <div className='icon-container'>
        <img alt="icon" loading="lazy" src={props.img} className='icon-container-img'/>
        <h4>{props.rating}{props?.extra}</h4>
        <p>{props.title}</p>
    </div>
  )
}

export default AboutIconContainer